export const CATEGORIES = {
  UNCATEGORIZED: 'uncategorized',
}

export const URL = {
  CHUCKAPI: 'https://api.chucknorris.io',
  TIMEOUT: 5000,
}

export const PAGE_LIMIT = 30

export const POPULARITY = {
  LOW: 'NEW IN TOWN',
  MEDIUM: 'TRENDING',
  HIGH: 'HALL OF FAME',
  BAD_REPUTATION: 'CHESTNUT',
}
